import http from 'plugins/axios';

export default {
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  getBillTypeList() {
    return http.get({
      url: '/la/admin/user/bill/type'
    });
  },
  getAccountType() {
    return http.get({
      url: '/la/admin/lever/order/type'
    });
  },
  reqBills(data) {
    return http.get({
      url: '/la/admin/user/bill',
      data
    });
  }
};
